import { Check } from "lucide-react";
import { ChatMarkdown } from "@/core/components/chat-markdown";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

interface LiveAssistantMessageProps {
  displayedLiveText: string;
  progressSteps: string[];
}

export const LiveAssistantMessage = ({
  displayedLiveText,
  progressSteps,
}: LiveAssistantMessageProps) => (
  <div className="mt-8 flex w-full">
    <div className="min-w-0 flex-1">
      {!displayedLiveText && progressSteps.length === 0 && (
        <div className="flex h-5 items-center gap-[3px]">
          {[0, 200, 400].map((delay) => (
            <span
              key={delay}
              className="h-1 w-1 rounded-full bg-green-50 motion-safe:animate-pulse"
              style={{ animationDelay: `${delay}ms` }}
            />
          ))}
        </div>
      )}
      {progressSteps.length > 0 && (
        <Stack
          gap="xs"
          className={cn({
            "mb-3": displayedLiveText,
          })}
        >
          {progressSteps.map((step, index) => {
            const isCurrent =
              index === progressSteps.length - 1 && !displayedLiveText;

            return (
              <div
                key={`${step}-${index}`}
                className="flex items-center gap-1.5"
              >
                <span className="flex h-4 w-4 shrink-0 items-center justify-center">
                  {isCurrent ? (
                    <span className="h-1.5 w-1.5 rounded-full bg-green-50 motion-safe:animate-pulse" />
                  ) : (
                    <Check className="h-3 w-3 text-green-50" />
                  )}
                </span>
                <Typography
                  variant="bodyW3"
                  textColor={isCurrent ? "secondary" : "tertiary"}
                >
                  {step}
                </Typography>
              </div>
            );
          })}
        </Stack>
      )}
      {displayedLiveText && (
        <ChatMarkdown streaming>{displayedLiveText}</ChatMarkdown>
      )}
    </div>
  </div>
);
